import React from 'react';
import { withRouter } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import Requirements from './Requirements';
import * as actions from '../../actions';

function RequirementsTabs({
  applicationRequirements,
  businessLinesRequirements
}) {

  return (
    <div className="p-3">
      <Tabs>
        <div className="row">
          <div className="col">
            <TabList
              style={{ overflow: 'auto', alignItems: 'flex-end' }}
            > 
              <Tab
                style={{ flex: 'none', textAlign: 'right' }}
              >
                Application
              </Tab>
              <Tab
                style={{ flex: 'none', textAlign: 'right' }}
              >
                Business Lines
              </Tab>
            </TabList>
            <TabPanel>
              <Requirements data={applicationRequirements} />
            </TabPanel>
            <TabPanel>
              <Requirements data={businessLinesRequirements} />
            </TabPanel>
          </div>
        </div>
      </Tabs>
    </div>
  );
}


RequirementsTabs.propTypes = {
  applicationRequirements: PropTypes.instanceOf(Array).isRequired,
  businessLinesRequirements: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(RequirementsTabs);
